module.exports = __webpack_public_path__ + "fonts/Montserrat-SemiBold.cfed6949.woff";